export default function () {
    function set(queryParams: { key: string; value: string }[]): void {
        const url = new URL(window.location.toString())

        queryParams.forEach((queryParam) => {
            url.searchParams.set(queryParam.key, queryParam.value)
        })

        window.history.pushState({}, '', url)
    }

    function replace(queryParams: { key: string; value: string }[]): string {
        const url = new URL(window.location.toString())

        queryParams.forEach((queryParam) => {
            if (url.searchParams.has(queryParam.key)) {
                url.searchParams.delete(queryParam.key)
            }

            url.searchParams.set(queryParam.key, queryParam.value)
        })

        return url.toString()
    }

    return {
        set,
        replace,
    }
}
